"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getAssetsFromURL;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
async function getAssetsFromURL(urlListObject = {}) {
    const urlListKeys = Object.keys(urlListObject);
    const responseObj = urlListKeys.reduce((returnObject, urlName)=>{
        if (urlListObject[urlName].url === null) {
            return _object_spread_props(_object_spread({}, returnObject), {
                [urlName]: Promise.resolve(null)
            });
        }
        returnObject[urlName] = fetch(urlListObject[urlName].url).then((response)=>{
            if (urlListObject[urlName].responseType === "arrayBuffer") {
                return response.arrayBuffer();
            } else {
                return response.json();
            }
        }).catch((err)=>`error: ${err}`);
        return returnObject;
    }, {});
    const responses = await Promise.all(Object.keys(responseObj).map((key)=>responseObj[key])).then((responseList)=>{
        return responseList.reduce((responseObject, response, index)=>{
            responseObject[urlListKeys[index]]["response"] = response;
            return _object_spread({}, responseObject);
        }, urlListObject);
    });
    return responses;
}
